module.exports = __webpack_public_path__ + "img/user-13.b7436eb4.jpg";